var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Kick start your project 🚀"}},[_c('b-button',{on:{"click":_vm.createData}},[_vm._v("Create ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }